import React, { useRef, useEffect, useState, memo, forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Switch from '@material-ui/core/Switch';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import FileCopyIcon from '@material-ui/icons/FileCopyOutlined';
import SaveIcon from '@material-ui/icons/Save';
import PrintIcon from '@material-ui/icons/Print';
import ShareIcon from '@material-ui/icons/Share';
import FavoriteIcon from '@material-ui/icons/Favorite';
import SatelliteIcon from '@material-ui/icons/Satellite';
import MapIcon from '@material-ui/icons/Map';
import LayersIcon from '@material-ui/icons/Layers';
import Fab from '@material-ui/core/Fab';

const useStyles = makeStyles((theme) => ({
    root: {
        transform: 'translateZ(0px)',
        flexGrow: 1,
    },
    exampleWrapper: {
        position: 'relative',
        marginTop: theme.spacing(3),
        height: 380,
    },
    radioGroup: {
        margin: theme.spacing(1, 0),
    },
    speedDial: {
        position: 'absolute',
        '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
            bottom: theme.spacing(2),
            right: theme.spacing(2),
        },
        '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
            top: theme.spacing(2),
            left: theme.spacing(2),
        },
    },
}));



const MapLayerDial = ({ setMapStyle, className }) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [currentStyle, setCurrentStyle] = useState(1);

    const actions = [
        { icon: <SatelliteIcon />, name: 'Satellite', mapStyle: { style: "ckqccqfbe03r718o40dwed8e0?optimize=true", dark: true } },
        { icon: <MapIcon />, name: 'Street Map', mapStyle: { style: "ckouk806n1vxr17lkaic8078y?optimize=true", dark: false } },
    ];

    const handleClose = (mapStyle) => {
        setOpen(false);
    };

    //const handleClick = (mapStyle) => {
    //    setMapStyle(mapStyle);
    //    setOpen(false);
    //};

    const handleClick = () => {
        let newStyle = currentStyle == 0 ? 1 : 0;
        setMapStyle(actions[newStyle].mapStyle);
        setCurrentStyle(newStyle);
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <Fab color="secondary" aria-label="add" className={className} onClick={() => handleClick()} >
            <LayersIcon />
        </Fab>
    );

    


}

export default memo(MapLayerDial);